import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import LoadingPageSm from "../../CommonComponent/LoadingPageSm";
import fetchAllRawSkills from "../../../apis/fetchAllRawSkills";
import addSkillToUser from "../../../apis/addSkillToUser";
import removeSkillToUser from "../../../apis/removeSkillToUser";
import getSkillsBySearchText from "../../../apis/getSkillsBySearchText";
import { useAuthContext } from "../../../context/AuthContext";
import { BsTrash, BsPlus } from "react-icons/bs";
import InputLebelComponent from "../../InputLebel/InputLebelComponent";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import swalWithBootstrapButtons from "sweetalert2-react-content";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const SkillSetV2 = (props) => {
  const { skillDetails, resourceSlug, profileName } = props;

  const MySwal = swalWithBootstrapButtons(Swal);
  const { userDetails } = useAuthContext();
  const user =
    typeof userDetails === "string" ? JSON.parse(userDetails) : userDetails;
  const user_slug = user?.user_slug;

  const [isLoading, setIsLoading] = useState(true);
  const [displayedSkills, setDisplayedSkills] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isLoadingSkillEdit, setIsLoadingSkillEdit] = useState(true);
  const [rawSkills, setRawSkills] = useState([]);
  const [skillSearchText, setSkillSearchText] = useState("");
  const [searchedSkills, setSearchedSkills] = useState([]);
  const [isLoadingSkillSearch, setIsLoadingSkillSearch] = useState(false);
  const [filterTextStatus, setFilterTextStatus] = useState(
    "Your search skills will be displayed here"
  );
  const [isProcessing, setIsProcessing] = useState(false);

  const handleCloseEditModal = () => setShowEditModal(false);
  const handleShowEditModal = () => setShowEditModal(true);

  useEffect(() => {
    if (skillDetails?.length) {
      setDisplayedSkills(skillDetails);
    }
    setIsLoading(false);
  }, [skillDetails]);

  useEffect(() => {
    if (showEditModal) {
      setIsLoadingSkillEdit(true);
      fetchSkills();
    }
  }, [showEditModal]);

  const fetchSkills = () => {
    fetchAllRawSkills(resourceSlug, user_slug)
      .then((res) => {
        if (res?.data?.status) {
          setRawSkills(res?.data?.skills);
        }
        setIsLoadingSkillEdit(false);
      })
      .catch(console.log);
  };

  const displaySkillItem = (item) => (
    <span className="badge-skill text-sm" key={item.skill_id}>
      {item.skill_name.length > 25
        ? `${item.skill_name.slice(0, 25)}...`
        : item.skill_name}
    </span>
  );

  const displaySearchSkillItem = (item, key) => (
    <button
      className="btn btn-sm my-1 me-1 mb-2 d-flex btn-success"
      key={item.skill_id || key}
      disabled={isProcessing}
      onClick={() => addSkill(item.skill_id, item)}
    >
      <span>{item.skill_name}</span>
      <div className="ms-2 pe-none cursor-pointer">
        <BsPlus className="text-light" />
      </div>
    </button>
  );

  const addSkill = (id, item) => {
    setIsProcessing(true);
    addSkillToUser(resourceSlug, id)
      .then((data) => {
        if (data?.data?.status) {
          setSearchedSkills((current) =>
            current.filter((s) => s.skill_id !== id)
          );
          setRawSkills((oldArray) => [...oldArray, item]);
          setDisplayedSkills((prev) => [...prev, item]);
          toast.success(data?.data?.message);
        } else {
          toast.warning(data?.data?.message);
        }
        setIsProcessing(false);
      })
      .catch((err) => {
        setIsProcessing(false);
        console.log(err);
      });
  };

  const removeSkill = (id, name) => {
    MySwal.fire({
      title: "Are you sure?",
      text: `that you want to remove ${name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      confirmButtonColor: "var(--danger)",
      cancelButtonColor: "var(--black)",
    }).then((result) => {
      if (result.isConfirmed) {
        processRemoveSkill(id);
      }
    });
  };

  const processRemoveSkill = (id) => {
    setIsProcessing(true);
    removeSkillToUser(resourceSlug, id)
      .then((data) => {
        if (data?.data?.status) {
          setRawSkills((current) => current.filter((s) => s.skill_id !== id));
          setDisplayedSkills((current) =>
            current.filter((s) => s.skill_id !== id)
          );
          toast.success(data?.data?.message);
        } else {
          toast.warning(data?.data?.message);
        }
        setIsProcessing(false);
      })
      .catch((err) => {
        setIsProcessing(false);
        console.log(err);
      });
  };

  const displayRawSkillItem = (item) => (
    <div
      className="badge-skill d-flex"
      key={item.skill_id}
      disabled={isProcessing}
      onClick={() => removeSkill(item.skill_id, item.skill_name)}
    >
      <span>{item.skill_name}</span>
      <div className="ms-2 pe-none cursor-pointer">
        <BsTrash className="text-danger" />
      </div>
    </div>
  );

  const handleTextChange = (e) => setSkillSearchText(e.target.value);

  useEffect(() => {
    if (skillSearchText.trim().length > 2) {
      const delay = setTimeout(() => {
        getSkillsWithSearchText();
      }, 500);
      return () => clearTimeout(delay);
    } else {
      setSearchedSkills([]);
      setFilterTextStatus("Your search skills will be displayed here");
    }
  }, [skillSearchText]);

  const getSkillsWithSearchText = () => {
    setIsLoadingSkillSearch(true);

    getSkillsBySearchText(skillSearchText, resourceSlug)
      .then((res) => {
        if (res?.data?.status === 1) {
          setSearchedSkills(res.data.skills);
        } else if (res?.data?.message) {
          setSearchedSkills([]);
          setFilterTextStatus(res.data.message);
        } else {
          setSearchedSkills([]);
          setFilterTextStatus("Something went wrong. Please try again.");
        }
      })
      .catch((err) => {
        console.error("Skill search failed:", err);
        setSearchedSkills([]);
        setFilterTextStatus("Server error occurred. Please try again later.");
      })
      .finally(() => {
        setIsLoadingSkillSearch(false);
      });
  };

  const displayNewSkillAdd = () => (
    <div className="form-input-holder">
      <InputLebelComponent title="Search Skills" />
      <input
        type="text"
        className="form-control"
        placeholder="Search skill to add"
        onChange={handleTextChange}
        value={skillSearchText}
        autoComplete="off"
      />
      <div className="border-dark p-2 rounded my-2 bg-light">
        {isLoadingSkillSearch ? (
          <LoadingPageSm />
        ) : searchedSkills.length ? (
          <>
            <div className="my-2">
              <span>Click on (+) to add new skill</span>
            </div>
            <div className="d-flex flex-wrap">
              {searchedSkills.map(displaySearchSkillItem)}
            </div>
          </>
        ) : (
          <span>{filterTextStatus}</span>
        )}
      </div>
    </div>
  );

  const displayAllRawSkills = () =>
    isLoadingSkillEdit ? (
      <LoadingPageSm />
    ) : (
      <>
        <div>
          <span className="fw-bold-custom">Current Skills</span>
        </div>
        <div className="d-flex flex-wrap">
          {rawSkills.length > 0 ? (
            rawSkills.map(displayRawSkillItem)
          ) : (
            <span className="text-muted">No skills found.</span>
          )}
        </div>
      </>
    );

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h6 className="mb-0">My Skills</h6>
        <FontAwesomeIcon
          icon={faEdit}
          className="text-primary cursor-pointer"
          title="Edit Skills"
          role="button"
          onClick={handleShowEditModal}
        />
      </div>

      {isLoading ? (
        <LoadingPageSm />
      ) : (
        <div>
          {displayedSkills && displayedSkills.length > 0 ? (
            displayedSkills.map(displaySkillItem)
          ) : (
            <small className="text-muted">Nothing to display here!</small>
          )}
        </div>
      )}

      {/* Edit Modal */}
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        centered
        scrollable
        backdrop="static"
      >
        <Modal.Header closeButton={false}>
          <span className="fw-bold-custom">Edit Skills for {profileName}</span>
        </Modal.Header>
        <Modal.Body>
          {displayNewSkillAdd()}
          {displayAllRawSkills()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseEditModal} size="sm">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SkillSetV2;
